import React from "react"

export const SavingsQuoteContext = React.createContext()